export const GENDER_OPTIONS = [
  { value: 'M', label: 'Male' },
  { value: 'F', label: 'Female' },
];

export const EVENT_GENDER_OPTIONS = [
  { value: 'Boys', label: 'Boys' },
  { value: 'Girls', label: 'Girls' },
  { value: 'Mixed', label: 'Mixed' },
  { value: 'Men', label: 'Men' },
  { value: 'Women', label: 'Women' },
];

// Only supporting admin and member roles for now
export const USER_PERMISSIONS = [
  {
    value: 'Admin',
    label: 'Administrator',
    text: 'An administrator can manage members and create and edit meets and results',
  },
  // {
  //   value: 'Official',
  //   label: 'Official',
  //   text: 'An official can view and edit results, but cannot edit member profiles',
  // },
  {
    value: 'Member',
    label: 'Member',
    text: 'A member can view results and meets, but cannot edit content',
  },
];

// The export formats on Event View and the Season Best Report, by the same names
// on both (Doug, 2026-10-25). rhq_excel is an Excel file for the ResultsHQ importer.
// The export dialog shows the chosen format's description under its Format box.
export const CSV_FORMAT_OPTIONS = [
  {
    value: 'rhq_excel',
    label: 'ResultsHQ Excel',
    description: "An Excel file in ResultsHQ's import format, ready to upload to ResultsHQ.",
  },
  {
    value: 'sf_csv',
    label: 'SplitFast csv',
    description: "A csv file with SplitFast's columns, for Excel or any spreadsheet.",
  },
];

export const RESULTS_EXPORT_SELECT_OPTIONS = [
  { value: 'all', label: 'All' },
  { value: 'none', label: 'None' },
  { value: 'pending', label: 'Pending' },
  { value: 'published', label: 'Published' },
];

export const BOOLEAN_OPTIONS = [
  { value: true, label: 'Yes' },
  { value: false, label: 'No' },
];
